const deletionRequests = [
	{
		path: '/network/deletion-requests',
		name: 'network-deletion-requests',
		component: () => import('@/views/network/deletion-requests/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGN,admin',
		},
	},
]

export default deletionRequests
